export const FILE_TYPES = {
  PDF: "pdf",
  EXCEL: "excel",
  ACCOUNTANT: "accountant",
  WEB: "web"
};

export const GET_PDF_FILE_WITHOUT_APPENDIX = "دریافت فایل PDF بدون پیوست";
export const GET_PDF_FILE_WITH_APPENDIX = "دریافت فایل PDF با پیوست";
export const GET_PDF_FILE = "دریافت فایل PDF";
export const GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITHOUT_APPENDIX =
  "دریافت فایل PDF به تفکیک سرفصل‌های حساب بدون پیوست";
export const GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITH_APPENDIX =
  "دریافت فایل PDF به تفکیک سرفصل‌های حساب با پیوست";
export const GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITHOUT_APPENDIX_DETAILED =
  "دریافت فایل PDF به تفکیک سرفصل‌های حساب با جزئیات و بدون پیوست";
export const GET_PDF_FILE_SEPARATED_BY_ACCOUNT_TITLE_WITH_APPENDIX_DETAILED =
  "دریافت فایل PDF به تفکیک سرفصل‌های حساب با جزئیات و با پیوست";
export const GET_PDF_FILE_WITH_BUDGET_COMPARISON =
  "دریافت فایل PDF مقایسه‌ای بودجه";
export const GET_PDF_FILE_WITH_DETAILS = "دریافت فایل PDF با جزئیات";
export const GET_PDF_FILE_WITH_DETAILS_BY = byText =>
  `دریافت فایل PDF با جزئیات بر اساس ${byText}`;

export const GET_EXCEL_FILE = "دریافت فایل EXCEL";
export const GET_EXCEL_FILE_SEPARATED_BY_ACCOUNT_TITLE =
  "دریافت فایل EXCEL به تفکیک سرفصل‌های حساب";
export const GET_EXCEL_FILE_WITH_BUDGET_COMPARISON =
  "دریافت فایل EXCEL مقایسه‌ای بودجه";
export const GET_EXCEL_FILE_WITH_DETAILS = "دریافت فایل EXCEL با جزئیات";
export const GET_EXCEL_FILE_WITH_DETAILS_BY = byText =>
  `دریافت فایل EXCEL با جزئیات بر اساس ${byText}`;

export const GET_ACCOUNTANT_FILE = "دریافت فایل سند حسابداری";
export const GET_ACCOUNTANT_FILE_SEPARATED_BY_ACCOUNT_TITLE =
  "دریافت فایل سند حسابداری به تفکیک سرفصل‌های حساب";
